import { z } from 'zod/v4';

import { columns, columnValidators } from './columns';

export const customerTermsAdjustmentSchema = z.object(columns);

export type LastTransactionAgeAdjustment = z.output<
  typeof customerTermsAdjustmentSchema
>;

export const customerTermsAdjustmentUpdateSchema = z.object(columnValidators);

export type LastTransactionAgeAdjustmentUpdate = z.output<
  typeof customerTermsAdjustmentUpdateSchema
>;
